import moment from "moment-timezone";

export const timeZoneCST = "America/Chicago";

export function todayCST (): moment.Moment {
    return moment().tz("America/Chicago");
}

export function todayCSTAsString (format = "MM/DD/YYYY"): string {
    return moment().tz("America/Chicago").format(format);
}